import React from 'react';
// import Link from 'next/link';
import Layout from "../../components/Layout";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import { fetchEntries } from '../../utils/contentfulBlogs';
import SectionGetQuoteFormCalculator from '../../components/landingSections/SectionGetQuoteFormCalculator';
import Loadable from '@loadable/component';
import { meta } from "../../utils/meta";
interface Props {
    landingPage: any;
}
export const LandingPage = (props: Props) => {
    // console.log(props.landingPage);
    return (
        <Layout title={meta.landingCal.title} description={meta.landingCal.description} keywords={meta.landingCal.keywords}>
            <div className="bg-white landing-bner-calc-wrap">
                <section className="grid place-center home landing-solar-panels-bay-area-ca pt-12 xxs:pt-20"
                    style={{ backgroundImage: "url(" + props.landingPage?.bannerImage?.fields?.file?.url + ")" }}>

                    <div className="px-4 pb-8 xxs:pb-0 pt-10 md:pt-6 container m-auto grid place-center">
                        <div
                            className="grid grid-cols-1 2md:grid-cols-2 gap-4 xxs:py-8 banner-height place-center items-center justify-center">
                            <div className="sm:py-8 xl:px-14 xl:pl-16">
                                <h1
                                    className="capitalize text-3xl xxs:text-4xl md:text-5xl font-primaryBold text-white max-w-xl 2md:max-w-lg lg:max-w-xl">
                                    {props.landingPage?.heading1}
                                    {props.landingPage?.heading2 ?
                                        <span className="text-primary">{' '}{props.landingPage?.heading2}</span>
                                        : ''
                                    }
                                </h1>
                                {props.landingPage?.description1 ? <p className="text-base xxs:text-xl text-gray-200 pt-3 lg:max-w-xl md:max-w-lg">
                                    {props.landingPage?.description1}
                                </p> : ''
                                }
                                {props.landingPage?.description2 ?
                                    <p className="text-base xxs:text-xl text-gray-200 py-3 lg:max-w-xl md:max-w-lg">
                                        {props.landingPage?.description2}
                                    </p> : ''
                                }
                                {/* <div className="flex flex-col text-gray-200">
                                <h1 className="text-xl xxs:text-2xl lg:text-3xl xxs:pt-4 text-white font-primaryMedium">Our solar
                                    solutions help you:</h1>
                                <div className="flex flex-row py-1 items-center pt-4">
                                    <div className=""><svg className="w-6 h-6 text-white mt-0" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg></div>
                                    <div className="px-4 my-auto">
                                        <p className="text-sm xxs:text-base xl:text-lg font-primaryMedium">Embrace renewable and
                                            green sources of energy</p>
                                    </div>
                                </div>
                                <div className="flex flex-row py-1 items-center">
                                    <div><svg className="w-6 h-6 text-white mt-0" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg></div>
                                    <div className="px-4 my-auto">
                                        <p className="text-sm xxs:text-base xl:text-lg font-primaryMedium">Cut down on your high
                                            energy bills</p>
                                    </div>
                                </div>
                                <div className="flex flex-row py-1 items-center">
                                    <div><svg className="w-6 h-6 text-white mt-0" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg></div>
                                    <div className="px-4 my-auto">
                                        <p className="text-sm xxs:text-base xl:text-lg font-primaryMedium">Protect your loved ones
                                            against power outages</p>
                                    </div>
                                </div>
                                <div className="flex flex-row py-1 items-center">
                                    <div><svg className="w-6 h-6 text-white mt-0" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg></div>
                                    <div className="px-4 my-auto">
                                        <p className="text-sm xxs:text-base xl:text-lg font-primaryMedium">Increase the value of
                                            your home</p>
                                    </div>
                                </div>
                            </div> */}
                                {/* <div className="py-4">
                                {props.landingPage?.freeQuoteButton ?
                                    <Link href="#">
                                        <a className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium px-12 py-2 xxs:my-4 text-base md:text-lg 2xl:text-xl"
                                        >{props.landingPage?.freeQuoteButton}</a>
                                    </Link> : ''
                                }
                            </div> */}
                            </div>
                            <div className="xl:px-14 xl:pl-16 xxs:flex flex-row  justify-center" id="quote-form">
                                <div className="bg-white 2md:rounded-xl max-w-48 shadow-lg-g w-full">

                                    {props.landingPage?.sections && (
                                        props.landingPage?.sections.map((item: any, index: number) => {
                                            // Here import dynamic component!
                                            if (item.fields.type == 'SectionGetQuoteFormCalculator') {
                                                return <SectionGetQuoteFormCalculator key={index} />;
                                            }
                                        })
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {props.landingPage?.sections && (
                props.landingPage?.sections.map((item: any, index: number) => {
                    // Here import dynamic component!
                    if (item.fields.type != 'SectionGetQuoteFormCalculator') {
                        const Module = Loadable(() => import(`../../components/landingSections/${item.fields.type}`))
                        return (
                            <Module
                                key={index}
                            />
                        )
                    }
                })
            )}
        </Layout >
    );
};

export default LandingPage;

export async function getStaticProps({ params }: { params: any }) {
    const res: any = await fetchEntries({ content_type: 'calculatorLandingPages', "fields.slug": params.slug });
    let landingPage = null;
    if (res.length > 0) {
        landingPage = { ...res[0].fields, createdAt: res[0].sys.createdAt, updatedAt: res[0].sys.updatedAt }
    }
    return {
        props: {
            landingPage
        },
    }
}

export async function getStaticPaths() {
    const res: any = await fetchEntries({ content_type: 'calculatorLandingPages' });
    const landingPages = await res.map((l: any) => {
        return l.fields
    });
    return {
        paths: landingPages.map((page: any) => {
            return {
                params: {
                    slug: page.slug,
                },
            }
        }),
        fallback: false,
    };
}
